<template>
  <v-container id="regular-tables" fluid tag="section" style="font-size:10px">
    <base-material-card color="#ed3325" icon="mdi-clipboard-text" title="Listado rutas" class="px-5 py-3">
        <template>
          <div style="font-size:24px;font-weight:bolder">Bienvenidos al centro de ayuda del sistema</div>
          <div style="font-size:16px;font-weight:lighter">Nos complace presentarles los siguientes videos</div>
          <v-row>
            <v-col v-for="(item, index) in videos" :key="index" sm="12">
              <h1 style="font-size: 18px;">{{ item.titulo }}</h1>
              <div style="font-size: 16px;">{{ item.descripcion }}</div>
              <div style="font-size: 12px;font-weight:700">{{ item.duration }}</div>
              <div style="margin:10px"></div>
              <iframe width="680" height="380" :src="item.video" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </v-col>
          </v-row>
        </template>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      videos: [
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video1-crear-cuenta.mp4',
          titulo: '¿Cómo crear mi cuenta?',
          descripcion: 'En este video te explicamos paso a paso, como puedes registrarte en nuestra plataforma',
          duration:'Duración 37 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video2-xml-y-pdf.mp4',
          titulo: '¿Cómo subir mi XML Y PDF?',
          descripcion: 'Una vez creada la solicitud por parte de Alogistic, podrás enviar tu XML y PDF',
          duration:'Duración 37 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video3-subir-evidencias.mp4',
          titulo: '¿Dónde subo mis evidencias?',
          descripcion: 'A continuación te explicamos como puedes enviar tus evidencias',
          duration:'Duración 37 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video4-ver-solicitud.mp4',
          titulo: '¿Dónde veo mi solicitud?',
          descripcion: 'En tu pantalla inicial podrás dar clic en opciones y ver solicitud',
          duration:'Duración 17 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video5-actualizar-evidencia.mp4',
          titulo: 'Me rechazaron mis evidencias, ¿Cómo las actualizo?',
          descripcion: 'En este video te mostramos como puedes actualizar tu documentación de evidencias',
          duration:'Duración 26 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video6-ver-pago.mp4',
          titulo: '¿Cómo saber si ya me pagaron?',
          descripcion: 'Contamos con un estatus de la solicitud, ademas te mostramos como puedes ver tu comprobante',
          duration:'Duración 12 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video7-perfil.mp4',
          titulo: '¿Dónde veo mi perfil de usuario?',
          descripcion: 'Aquí te enseñaremos como puedes ver el perfil de usuario y toda tu documentación',
          duration:'Duración 16 segundos'
        },
        {
          video: 'https://novacontrol.io/wp-content/uploads/2023/10/video8-actualizar-documentos.mp4',
          titulo: '¿Cómo actualizar mi documentación?',
          descripcion: 'A continuación te presentamos los pasos para actualizar tus documentos',
          duration:'Duración 14 segundos'
        },
      ]
    }
  },
}
</script>

<style>

</style>
